import * as React from "react";
import Grid from "@mui/material/Grid";
import styled from "@mui/material/styles/styled";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Button } from "../../Button";
const StyleEnrollMembers = styled("div")(() => {
    return {
        ".MuiTableRow-head": {
            th: {
                color: "#454d58",
                paddingBottom: 0,
                fontSize: 14,
                textAlign: "left",
                fontFamily: "Roboto",
                fontWeight: "normal",
                borderBottom: "none",
                zIndex: 0,
                letterSpacing: 1.12,
            },
        },
        ".MuiTableBody-root": {
            "tr:first-of-type": {
                td: {
                    fontFamily: "Roboto",
                    fontSize: 14,
                    fontWeight: 600,
                },
            },
            td: {
                fontWeight: 500,
            },
        },
        ".update-household": {
            marginTop: 20,
            marginBottom: 10,
            ".Mui-disabled": {
                color: "#ccc !important",
                borderColor: "#ccc !important",
            },
            ".MuiButtonBase-root": {
                width: "max-content",
                borderRadius: 30,
                border: "2px solid #41b5c2 !important",
                fontFamily: "Oswald",
                fontSize: 20,
                fontWeight: 600,
                textAlign: "center",
                color: "#41b5c2 !important",
                backgroundColor: "#fff",
                padding: "4px 26px",
                letterSpacing: 'normal'
            },
        },
    };
});
export const EnrolledMembers = (props) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    return (React.createElement(StyleEnrollMembers, null,
        React.createElement(TableContainer, { sx: { maxHeight: 440 } },
            React.createElement(Table, { stickyHeader: true, "aria-label": "sticky table" },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null, props.headings.map((column) => (React.createElement(TableCell, { sx: { fontWeight: 500 }, key: column.id }, column.label))))),
                React.createElement(TableBody, null, props.list
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                    return (React.createElement(TableRow, { hover: true, tabIndex: -1, key: index }, props.headings.map((column) => {
                        return (React.createElement(TableCell, { key: column.id }, row[column.id]));
                    })));
                })))),
        props.list.length > 10 ? (React.createElement(TablePagination, { rowsPerPageOptions: [10, 25, 100], component: "div", count: props.list.length, rowsPerPage: rowsPerPage, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage })) : null,
        React.createElement(Grid, { item: true, xs: 12, className: "update-household" },
            React.createElement(Button, { label: "UPDATE HOUSEHOLD", variant: "outlined", onClick: props.updateHouseHold, disabled: Boolean(props.updateHouseHoldDisable) }))));
};
